/**
 * Builds warehouse inventory v2 search filter params from search bar query params.
 *
 * @param {{ searchBy?: string, searchTerm?: string | number, type?: string }} queryParams
 * @returns {Array<{ searchBy: string, searchTerm: string | number }>}
 */
export function buildInventorySearchValues(queryParams = {}) {
    const searchValues = [{ searchBy: queryParams.searchBy, searchTerm: queryParams.searchTerm }];

    if (queryParams.type) {
        searchValues.push({ searchBy: 'type', searchTerm: queryParams.type });
    }

    return searchValues;
}

/**
 * Stable string key for searchValues arrays (for effect dependencies).
 *
 * @param {Array<{ searchBy?: string, searchTerm?: string | number }>} [searchValues=[]]
 * @returns {string}
 */
export function getInventorySearchValuesKey(searchValues = []) {
    return searchValues.map(({ searchBy, searchTerm }) => `${searchBy ?? ''}:${searchTerm ?? ''}`).join('|');
}
